import type { MarketplaceTemplate } from './use-marketplace-api';

export function isAgentTemplate(template: MarketplaceTemplate): boolean {
  return (
    template.agentDefinition?.identity.badge === 'agent' ||
    template.templateFacets?.includes('agent') === true
  );
}

export function isCustomAppTemplateType(templateType: string): boolean {
  return templateType === 'app' || templateType === 'app_block';
}

export function isRepeatableBlueprint(template: MarketplaceTemplate): boolean {
  return (
    template.templateType === 'app' ||
    template.templateType === 'automation' ||
    template.templateType === 'workflow' ||
    template.templateType === 'app_block'
  );
}

export function supportsMarketplaceReinstall(input: {
  templateType: MarketplaceTemplate['templateType'] | string;
  installedDocIds?: readonly string[];
}): boolean {
  // Only document templates retain an explicit re-import/reinstall flow.
  // No Marketplace artifact grants its publisher in-place runtime authority.
  return input.templateType === 'doc';
}
